import {useScreenSizeDetector} from "./useScreenSizeDetector";
import {useProductDetailsQuery} from "./useProductDetailsQuery";

export const useAddToCartQuery = () => {
    const {model: {isDesignerProduct, isPurchasable}} = useProductDetailsQuery();
    const {isSmallScreenSize} = useScreenSizeDetector();

    return {
        model: {
            isStandardProduct: !isDesignerProduct,
            isSmallScreenSize,
            isPurchasable
        }
    }
}